import { render, staticRenderFns } from "./CampaignTableRow.vue?vue&type=template&id=ebb22406&scoped=true&"
import script from "./CampaignTableRow.vue?vue&type=script&lang=ts&"
export * from "./CampaignTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignTableRow.vue?vue&type=style&index=0&id=ebb22406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb22406",
  null
  
)

export default component.exports